// extracted by mini-css-extract-plugin
module.exports = {"apptInfo":"AppointmentInfo_apptInfo__VFBdW","title":"AppointmentInfo_title__zOk2G","infoItem":"AppointmentInfo_infoItem__sa2DW"};